import { create } from 'zustand';

import { badgeCountGet, badgeClearPost } from '@/services/swagger/easourcing/ReportService';

interface ReportBadgeState {
  badgeCount: number;
  fetchBadgeCount: () => Promise<void>;
  clearBadge: () => Promise<void>;
}

const useReportBadgeStore = create<ReportBadgeState>(set => ({
  badgeCount: 0,

  fetchBadgeCount: async () => {
    try {
      const result = await badgeCountGet();
      if (result?.data) {
        set({ badgeCount: result.data.count ?? 0 });
      }
    } catch (error) {
      console.error('Failed to fetch badge count:', error);
    }
  },

  clearBadge: async () => {
    try {
      await badgeClearPost();
      set({ badgeCount: 0 });
    } catch (error) {
      console.error('Failed to clear badge:', error);
    }
  },
}));

export default useReportBadgeStore;
